import * as MessagesQueueSelectors from '../messages_queue/selectors';
import * as User                   from '../user';
import { getResources }            from 'redux-resource';
import { getResourceStatuses }     from '../util/get_resource_statuses';
import { getStatus }               from 'redux-resource';


export function getConversations(state, businessID) {
  return getResources(state.conversations, businessID);
}


function getConversationsReadStatus(state, businessID) {
  return getStatus(state.conversations, `requests.read-${businessID}.status`);
}


function getConversationsReadStatusCode(state, businessID) {
  return state.conversations.requests[`read-${businessID}`] ?
    state.conversations.requests[`read-${businessID}`].statusCode :
    null;
}


export function getConversationsStatuses(state, businessID) {
  return {
    createStatus:   {},
    deleteStatus:   {},
    readStatus:     getConversationsReadStatus(state, businessID),
    readStatusCode: getConversationsReadStatusCode(state, businessID),
    updateStatus:   {}
  };
}

export function getConversation(state, conversationID) {
  return getResources(state.conversations, [ conversationID ])[0];
}

export function getConversationReadStatus(state, conversationID) {
  return getStatus(state.conversations, `meta[${conversationID}].readStatus`);
}

export function getConversationsCreateStatus(state, businessID) {
  return getStatus(state.conversations, `requests.create-${businessID}.status`);
}

export function getConversationUpdateStatus(state, conversationID) {
  return getStatus(state.conversations, `meta[${conversationID}].updateStatus`);
}

export function getActivities(state, conversationID) {
  const [ conversation ] = getResources(state.conversations, [ conversationID ]);
  return conversation?.activities;
}


export function getActivitiesWithPendingQueue(state, conversationID) {
  const activities = getActivities(state, conversationID);
  const customerID = getCustomerID(state, conversationID);
  if (activities) {
    const messagesInQueue   = MessagesQueueSelectors.getContactMessagesQueue(state, customerID);
    const userName          = User.getUserName(state);
    const activitiesInQueue = mapMessagesInQueueToActivities(messagesInQueue, userName);
    return activities.concat(activitiesInQueue).sort(byTimestamp);
  } else
    return null;
}

function getCustomerID(state, conversationID) {
  const [ conversation ] = getResources(state.conversations, [ conversationID ]);
  return conversation?.customers?.[0]?.id;
}


export function getConversationStatuses(state, conversationID) {
  return getResourceStatuses(state.conversations, conversationID);
}


function byTimestamp(a, b) {
  const timestampA = new Date(a.timestamp).getTime();
  const timestampB = new Date(b.timestamp).getTime();
  return timestampA - timestampB;
}

function mapMessagesInQueueToActivities(messagesInQueue = [], userName) {
  return messagesInQueue.map(message => {
    return {
      type:      'OutgoingMessage',
      timestamp: message.timestamp,
      message:   {
        attachments: message.attachments,
        body:        message.body,
        id:          message.id,
        progress:    message.progress,
        status:      message.status,
        user:        {
          name: userName
        }
      }
    };
  });
}
